var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{attrs:{"id":"trigger-anchor"}}),_c('el-popover',_vm._g(_vm._b({attrs:{"placement":"top","trigger":"click"}},'el-popover',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_c('div',{attrs:{"slot":"reference"},slot:"reference"},[_vm._t("ref")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }